/**
 * detect when document scroll is over middle impact numbers
 * then show second slide
 */
function middleImpactNumbers() {
    if (window.innerWidth > 749) {
        const target = document.querySelector('.impact-numbers')
        if (target) {
            const threshold = Math.round(target.getBoundingClientRect().top - window.innerHeight / 2 + (target.getBoundingClientRect().height / 2))
            const slider = target.querySelector('.slider')
            if (slider) {
                if (threshold < 0) {
                    slider.classList.add('second')
                } else {
                    slider.classList.remove('second')
                }
            }
        }
    }
}

/**
 * change green circle position
 * mobile version for full-image
 */
function moveGreenCircle() {
    if (window.innerWidth < 749) {
        const target = document.querySelector('.full-image .green-circle')
        const dots = document.querySelectorAll('.full-image .dot')
        const dotActive = document.querySelector('.full-image .dot.active')
        let index = 1
        dots.forEach((item) => {
            target.classList.remove('position-'+index)
            index++
        })
        index = 1
        dots.forEach((item) => {
            if (item === dotActive) {
                target.classList.add('position-'+index)
            }
            index++
        })
    }
}

function snrInit() {
    document.addEventListener('scroll', middleImpactNumbers)
    const slider = document.querySelector('.full-image .slider')
    if (slider) {
        slider.addEventListener('scroll', moveGreenCircle)
    }
}

document.addEventListener('DOMContentLoaded', snrInit)